@if ($selectedCameraId() === undefined) {
    <cm-zoom-button [threeViewer]="$threeViewer()" matTooltip="Zoom (click+hold)"></cm-zoom-button>
}
<i class="far fa-gear" matTooltip="Editor Settings" [matMenuTriggerFor]="editorConfigurationMenu">
    <mat-menu #editorConfigurationMenu>
        <div class="cm-editor-settings-menu">
            <mat-button-toggle-group
                class="cm-toggle-group"
                [value]="sceneManagerService.$lodType()"
                (change)="sceneManagerService.$lodType.set($event.value)"
                [hideSingleSelectionIndicator]="true"
            >
                <mat-button-toggle [matTooltip]="$getLodTypeDescription()('web')" [value]="'web'" (click)="$event.stopPropagation()">{{
                        $getLodTypeDescription()("web")
                    }}
                </mat-button-toggle>
                <mat-button-toggle [matTooltip]="$getLodTypeDescription()('ar')" [value]="'ar'" (click)="$event.stopPropagation()">{{
                        $getLodTypeDescription()("ar")
                    }}
                </mat-button-toggle>
                <mat-button-toggle [matTooltip]="$getLodTypeDescription()('pathTraced')" [value]="'pathTraced'" (click)="$event.stopPropagation()">{{
                        $getLodTypeDescription()("pathTraced")
                    }}
                </mat-button-toggle>
            </mat-button-toggle-group>
            @if (!threeSceneManagerService.$hasIllumination()) {
                <cm-toggle
                    (click)="$event.stopPropagation()"
                    [toggle]="threeSceneManagerService.$ambientLight() && localPreviewRenderingService.$ambientLight()"
                    (toggleChange)="threeSceneManagerService.$ambientLight.set($event); localPreviewRenderingService.$ambientLight.set($event)"
                >
                    <ng-container cm-text>Ambient Light</ng-container>
                </cm-toggle>
            }
            <cm-toggle
                (click)="$event.stopPropagation()"
                [toggle]="threeSceneManagerService.$showGrid()"
                (toggleChange)="threeSceneManagerService.$showGrid.set($event)"
            >
                <ng-container cm-text>Show Grid</ng-container>
            </cm-toggle>
            <cm-toggle
                (click)="$event.stopPropagation()"
                [toggle]="threeSceneManagerService.$showProgressiveLightMapDebug()"
                (toggleChange)="threeSceneManagerService.$showProgressiveLightMapDebug.set($event)"
            >
                <ng-container cm-text>Debug Shadows</ng-container>
            </cm-toggle>
            <cm-toggle
                (click)="$event.stopPropagation()"
                [toggle]="threeSceneManagerService.$showUnselectedCurves()"
                (toggleChange)="threeSceneManagerService.$showUnselectedCurves.set($event)"
            >
                <ng-container cm-text>Show All Curves</ng-container>
            </cm-toggle>
            <cm-toggle
                (click)="$event.stopPropagation()"
                [toggle]="localPreviewRenderingService.$enable()"
                (toggleChange)="localPreviewRenderingService.$enable.set($event)"
            >
                <ng-container cm-text>Local Rendering Preview</ng-container>
            </cm-toggle>
            @if (localPreviewRenderingService.$enable()) {
                <div class="cm-menu-section">
                    @if (localPreviewRenderingService.$connected()) {
                        <div class="cm-status-text cm-connected"><i class="fas fa-check-circle"></i> Connected</div>
                    } @else {
                        <div class="cm-status-text cm-disconnected"><i class="fas fa-times-circle"></i> Not Connected</div>
                    }

                    <div class="cm-truncated-label-wrapper">
                        <div class="cm-status-text cm-truncated-label" [title]="localPreviewRenderingService.$statusMessage()">
                            Status: {{ localPreviewRenderingService.$statusMessage() }}
                        </div>
                    </div>

                    @if (localPreviewRenderingService.$errorMessage(); as errorMessage) {
                        <div class="cm-truncated-label-wrapper">
                            <div class="cm-status-text cm-error cm-truncated-label" [title]="errorMessage">
                                <i class="fas fa-exclamation-triangle"></i> {{ errorMessage }}
                            </div>
                        </div>
                    }

                    <cm-toggle
                        (click)="$event.stopPropagation()"
                        [toggle]="localPreviewRenderingService.$fullQuality()"
                        (toggleChange)="localPreviewRenderingService.$fullQuality.set($event)"
                    >
                        <ng-container cm-text>Production materials</ng-container>
                    </cm-toggle>

                    <cm-toggle
                        (click)="$event.stopPropagation()"
                        [toggle]="localPreviewRenderingService.$useGPU()"
                        (toggleChange)="localPreviewRenderingService.$useGPU.set($event)"
                    >
                        <ng-container cm-text>Use GPU</ng-container>
                    </cm-toggle>

                    <div
                        class="cm-mini-dropdown"
                        (click)="$event.stopPropagation()"
                        [matMenuTriggerFor]="passMenu"
                        #passMenuTrigger="matMenuTrigger"
                    >
                        <span class="cm-mini-dropdown-label">Preview Pass:</span>
                        <span class="cm-mini-dropdown-value">{{ labelFor(localPreviewRenderingService.availablePasses, localPreviewRenderingService.$pass()) }}</span>
                        <i class="far fa-circle-caret-down cm-button"></i>
                    </div>
                    <mat-menu #passMenu>
                        @for (option of localPreviewRenderingService.availablePasses; track option.value) {
                            <cm-list-item
                                [selected]="option.value === localPreviewRenderingService.$pass()"
                                (click)="$event.stopPropagation(); localPreviewRenderingService.$pass.set(option.value); passMenuTrigger.closeMenu()"
                            >
                                <ng-container cm-title>{{ option.name }}</ng-container>
                            </cm-list-item>
                        }
                    </mat-menu>

                    <div
                        class="cm-mini-dropdown"
                        (click)="$event.stopPropagation()"
                        [matMenuTriggerFor]="textureStreamingMenu"
                        #textureStreamingMenuTrigger="matMenuTrigger"
                    >
                        <span class="cm-mini-dropdown-label">Texture Streaming:</span>
                        <span class="cm-mini-dropdown-value">{{
                                labelFor(localPreviewRenderingService.availableTextureStreamingOverrides, localPreviewRenderingService.$textureStreaming())
                            }}</span>
                        <i class="far fa-circle-caret-down cm-button"></i>
                    </div>
                    <mat-menu #textureStreamingMenu>
                        @for (option of localPreviewRenderingService.availableTextureStreamingOverrides; track option.value) {
                            <cm-list-item
                                [selected]="option.value === localPreviewRenderingService.$textureStreaming()"
                                (click)="
                                    $event.stopPropagation();
                                    localPreviewRenderingService.$textureStreaming.set(option.value);
                                    textureStreamingMenuTrigger.closeMenu()
                                "
                            >
                                <ng-container cm-title>{{ option.name }}</ng-container>
                            </cm-list-item>
                        }
                    </mat-menu>

                    <div
                        class="cm-mini-dropdown"
                        (click)="$event.stopPropagation()"
                        [matMenuTriggerFor]="textureResolutionMenu"
                        #textureResolutionMenuTrigger="matMenuTrigger"
                    >
                        <span class="cm-mini-dropdown-label">Texture Resolution:</span>
                        <span class="cm-mini-dropdown-value">{{
                                labelFor(localPreviewRenderingService.availableTextureResolutions, localPreviewRenderingService.$textureResolution())
                            }}</span>
                        <i class="far fa-circle-caret-down cm-button"></i>
                    </div>
                    <mat-menu #textureResolutionMenu>
                        @for (option of localPreviewRenderingService.availableTextureResolutions; track option.value) {
                            <cm-list-item
                                [selected]="option.value === localPreviewRenderingService.$textureResolution()"
                                (click)="
                                    $event.stopPropagation();
                                    localPreviewRenderingService.$textureResolution.set(option.value);
                                    textureResolutionMenuTrigger.closeMenu()
                                "
                            >
                                <ng-container cm-title>{{ option.name }}</ng-container>
                            </cm-list-item>
                        }
                    </mat-menu>

                    <cm-toggle
                        (click)="$event.stopPropagation()"
                        [toggle]="localPreviewRenderingService.$overlayHelpers()"
                        (toggleChange)="localPreviewRenderingService.$overlayHelpers.set($event)"
                    >
                        <ng-container cm-text>Overlay Helpers</ng-container>
                    </cm-toggle>
                </div>
            }
            <cm-toggle
                (click)="$event.stopPropagation()"
                [toggle]="blenderConnectorService.$enable()"
                (toggleChange)="blenderConnectorService.$enable.set($event)"
            >
                <ng-container cm-text>Connect to Blender</ng-container>
            </cm-toggle>
            @if (blenderConnectorService.$enable()) {
                <div class="cm-menu-section">
                    @if (blenderConnectorService.$state() === "Connected") {
                        <div class="cm-status-text cm-connected"><i class="fas fa-check-circle"></i> Connected</div>
                    } @else {
                        <div class="cm-status-text cm-disconnected"><i class="fas fa-times-circle"></i> Not Connected</div>
                    }
                </div>
            }
            <cm-toggle
                (click)="$event.stopPropagation()"
                [toggle]="sceneManagerService.$reviewMode() !== undefined"
                (toggleChange)="sceneManagerService.$reviewMode.set($event ? 'wireframe' : undefined)"
            >
                <ng-container cm-text>Review</ng-container>
            </cm-toggle>
            @if (sceneManagerService.$reviewMode(); as reviewMode) {
                <mat-button-toggle-group
                    class="cm-toggle-group"
                    [value]="reviewMode"
                    (change)="sceneManagerService.$reviewMode.set($event.value)"
                    [hideSingleSelectionIndicator]="true"
                >
                    <mat-button-toggle matTooltip="Wireframe" [value]="'wireframe'" (click)="$event.stopPropagation()">Wireframe</mat-button-toggle>
                    <mat-button-toggle matTooltip="UV Test" [value]="'uvTest1'" (click)="$event.stopPropagation()">UV Test</mat-button-toggle>
                    <mat-button-toggle matTooltip="UV Test 2" [value]="'uvTest2'" (click)="$event.stopPropagation()">UV Test 2</mat-button-toggle>
                </mat-button-toggle-group>

                <mat-button-toggle-group
                    class="cm-toggle-group"
                    [value]="reviewMode === 'wireframe' ? sceneManagerService.$reviewFocus() : sceneManagerService.$reviewedUvChannel()"
                    (change)="sceneManagerService.$reviewFocus.set($event.value)"
                    [hideSingleSelectionIndicator]="true"
                >
                    @if (reviewMode === "wireframe") {
                        <mat-button-toggle matTooltip="Faces" [value]="'faces'" (click)="$event.stopPropagation()">Faces</mat-button-toggle>
                    }
                    <mat-button-toggle matTooltip="UV" [value]="'uv0'" (click)="$event.stopPropagation()">UV</mat-button-toggle>
                    <mat-button-toggle matTooltip="UV1" [value]="'uv1'" (click)="$event.stopPropagation()">UV1</mat-button-toggle>
                    <mat-button-toggle matTooltip="UV2" [value]="'uv2'" (click)="$event.stopPropagation()">UV2</mat-button-toggle>
                </mat-button-toggle-group>
            }
        </div>
    </mat-menu>
</i>
@if (sceneManagerService.$cameras().length > 0 && this.threeSceneManagerService.$displayMode() === "editor") {
    <cm-toggle
        (click)="$event.stopPropagation()"
        [toggle]="$selectedCameraId() !== undefined"
        (toggleChange)="selectedCameraIdChanged.emit($event ? sceneManagerService.$cameras()[0].id : undefined)"
    >
        <ng-container cm-text>Camera</ng-container>
    </cm-toggle>
}
<i class="far fa-camera" matTooltip="Capture Snapshot" (click)="captureSnapshot()"> </i>
